<template>
  <div class="setCountry notranslate" :class="{hiddenFlag: hiddenFlag, isOpen: openLang, isPageOnly: isPageOnly}">
    <button
      type="button"
      class="btnCountry"
      :style="{ ...skinStyle('languageBg', 'background-color'), ...skinStyle('languageText', 'color')}"
      @click.stop="openLang = true">
      <img :src="require(`@/assets/img/country/${setLang}.svg`)" alt="" class="languageFlag">
      <div class="utilIcon icoLang" :style="{ ...skinStyle('languageText', 'background-color')}"></div>
      <span class="name">{{langName}}</span>
    </button>
    <LanguageList
      v-if="openLang"
      :locale="locale"
      :setting="setting"
      @close="openLang = false" />
  </div>
</template>

<script>
import LanguageList from './LanguageList'

export default {
  props: [
    'locale',
    'responsive',
    'setting',
    'lang',
    'isPageOnly'
  ],
  components: {
    LanguageList
  },
  computed: {
    dimmed () {
      return this.$store.state.dimmed
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    ln () {
      return this.$route.params.ln
    },
    setLang: {
      get () {
        return this.ln
      },
      set (ln) {
        this.$store.dispatch('common/setLang', ln)
        this.$store.commit('system/setLocale', ln)
      }
    },
    langName () {
      return this.setting.lang.info.find(x => x.c === this.setLang).n
    },
    hiddenFlag () {
      return this.setting.lang.hiddenLangFlag
    }
  },
  data () {
    return {
      openLang: false
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    selectLang () {
      this.openLang = !this.openLang
      this.closeSelectLang()
    },
    closeSelectLang (e) {
      if (e.target.closest('.countryList') === null) {
        this.openLang = false
        document.removeEventListener('click', this.closeSelectLang)
      }
    },
    onClickMenu () {
      const dimmed = !this.dimmed
      this.$store.commit('dimmed', dimmed)
    },
    onClickDimm () {
      this.$store.commit('dimmed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.btnCountry {
  position: absolute;
  top: 12px;
  right: 15px;
  width: 26px;
  height: 26px;
  font-size: 0;
  border-radius: 100%;
  overflow: hidden;
  z-index: 9;
  transition: all 0.3s;
}
.countryList {
  position: fixed;
  top: 50px;
  right: 0;
  min-width: 100px;
  max-height: calc(100% - 60px);
  font-family: 'Pretendard';
  border: 1px solid rgba(0,0,0,0.1);
  border-top: none;
  border-right: none;
  overflow: auto;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  z-index: 1;
  li {
    font-size: 0;
    border-top: 1px solid rgba(0,0,0,0.1);
    background-color: $color-white;
    img {
      width: 24px;
      margin-right: 8px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
      font-size: 12px;
    }
    label {
      opacity: 0.6;
    }
    &.active {
      label {
        opacity: 1;
      }
    }
    input {
      position: absolute;
      left: -9999px;
      width: 1px;
      height: 1px;
      margin: -1px;
      overflow: hidden;
      opacity: 0;
    }
    label {
      display: block;
      padding: 5px;
    }
  }
}
.hiddenFlag {
  .countryList {
    label {
      padding: 8px;
    }
    img {
      display: none;
    }
  }
}
@media screen and (min-width: 768px) {
  .setCountry {
    position: relative;
    padding: 5px 10px 15px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    // background-color: $color-white;
    box-shadow: 0 5px 5px rgba(0,0,0,0.05);
  }
  .btnCountry {
    position: relative;
    top: auto;
    right: auto;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .countryList {
    position: absolute;
    top: 100%;
    left: 15px;
    right: 15px;
    margin-top: -15px;
    max-height: 300px;
  }
  .roomKeyInfo {
    padding-top: 15px;
  }
  @media screen and (max-width: 1023px) {
    .countryList {
      left: 0;
      right: 0;
      width: auto;
      margin-top: -5px;
      min-width: 0;
      max-height: 500px;
      text-align: center;
      box-shadow: 0 5px 5px rgba(0,0,0,0.1);
      li {
        img {
          margin-right: 0;
        }
        span {
          display: block;
          margin-top: 2px;
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .setCountry {
    padding-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
    // background-color: inherit;
  }
  .btnCountry {
    display: flex;
    align-items: center;
    width: 100%;
    height: auto;
    padding: 8px 0 8px 15px;
    line-height: 1;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.1);
    background-color: $color-white;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 15px;
      width: 8px;
      height: 8px;
      margin-top: -8px;
      border-bottom: 2px solid rgba(0,0,0,0.2);
      border-right: 2px solid rgba(0,0,0,0.2);
      transform: rotate(45deg);
    }
    img {
      height: 26px;
    }
    .name {
      margin-left: 1em;
      font-size: 14px;
    }
  }
  .hiddenFlag {
    .countryList {
      label {
        padding: 10px 8px;
      }
    }
    .btnCountry {
      padding: 15px 0 15px 8px;
      img {
        display: none;
      }
    }
  }
}
</style>
